import React from 'react'

import { Contract, UserMetadata } from '../../../../common/validations'
import { useCurrentContract } from '../../../hooks/useCurrentContract/useCurrentContract'
import { useAPIGetContractSuspense } from '../../../api/apiHooks/useAPIGetContract'
import { useAPIGetUserMetadataSuspense } from '../../../api/apiHooks/useAPIGetUserMetadata'

type Data = {
  contract: Contract
  userMetadata: UserMetadata
}

export const AddTenantDataLoader = ({
  children,
}: {
  children: (data: Data) => React.ReactNode
}) => {
  const { currentContractId } = useCurrentContract()
  const { data: contractData } = useAPIGetContractSuspense(currentContractId)
  const { data: userMetadata } = useAPIGetUserMetadataSuspense()

  return children({
    contract: contractData,
    userMetadata,
  })
}
